import httpClient from '@/_shared/http-client';

const getMatchedItem = async(barcode) => {
  const url = new URL('/inventory/item', process.env.BACKEND_URL);
  url.searchParams.set('query', barcode);
  const response = await httpClient.get(url);
  return response;
};

export const inventoryService = {
  getMatchedItem,
};



// WEBPACK FOOTER //
// ./src/stock/api-services/inventoryService.js